import vSelect from 'vue-select'
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
const DEFAULT_STATUSES = [
  'brand_new',
  'expired',
  'aborted',
  'started_completion',
  'completed',
  'not_collected',
  'service_required',
  'removed_by_support',
  'collected',
  'delivery_attempt_failed',
  'collection_attempt_failed',
]

export default {
  name: 'DrFiltersModal',
  components: { vSelect },
  extends: BaseModal,
  data: function () {
    return {
      statusIn: [],
      defaultStatuses: [],
    }
  },
  mounted() {
    this.defaultStatuses = this.generateDefaultStatuses(DEFAULT_STATUSES)
    this.statusIn = this.defaultStatuses.filter(statusObj => {
      return [...this.data.search.statusIn].includes(statusObj.val)
    })
  },
  computed: {
    statusInStringsArray() {
      let a = this.statusIn.map(statusObj => {
        return statusObj.val
      })
      console.log('statuses send from modal', a)
      return a
    },
  },
  methods: {
    generateDefaultStatuses(statuses) {
      return statuses.map(status => {
        return { label: this.$t(`deliveries.${status}`), val: status }
      })
    },
  },
}
